module.exports = [{
      plugin: require('/Users/buccia/Repository/studiolegalepacchioni/node_modules/gatsby-plugin-layout/gatsby-browser.js'),
      options: {"plugins":[],"component":"/Users/buccia/Repository/studiolegalepacchioni/src/layouts/index.js"},
    },{
      plugin: require('/Users/buccia/Repository/studiolegalepacchioni/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
